module.exports = __webpack_public_path__ + "static/payment_provider-b953b0eab108bbedc39edd3b317f4d94.svg";